module.exports = __webpack_public_path__ + "static/img/equipamiento-six-3.7bef0df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/equipamiento-six-3.jpg
// module id = 1ArP
// module chunks = 1